import { render } from "./CheckoutDeliveryInfo.vue?vue&type=template&id=3b4c9c15"
import script from "./CheckoutDeliveryInfo.vue?vue&type=script&lang=js"
export * from "./CheckoutDeliveryInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__